
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import MyCourse from './classroom/views/MyCourse/index.vue'
import MyStudy from './classroom/views/MyStudy/index.vue'
import MyAccount from './classroom/views/MyAccount/index.vue'
import MyCalendar from './classroom/views/MyCalendar/index.vue'
import Experience from './classroom/views/Experience/index.vue'
import Book from './classroom/views/Book/index.vue'
import HeaderUserPanel from './classroom/views/HeaderUserPanel/index.vue'
import ExpireBishanPop from './classroom/views/ExpireBishanPop/index.vue'
import StudyRecord from './classroom/views/StudyRecord/index.vue'
import CalendarMonthPop from './classroom/views/CalendarMonthPop/index.vue'
import UserContentPop from '@xt/www/components/classhour/pop-content/index.vue'
import StudentCardPop from './classroom/views/StudentCard/index.vue'
import type { HomeworkOption, DairyOption } from '@xt/client/entities/course-v2/user-content'
import type { MyLastReviewResponse, CourseCardUIType, CourseRecordCardUIType } from '@xt/client/entities/my-v2/types'
import type { CourseItem } from '@xt/client/types/my-go-course'
import { EnumApiMy } from '@xt/client'
import { EnumOpenMiniProgramPage, EnumOpenMiniProgramType, EnumProductTypeQuery, EnumProductType, EnumBizType } from '@xt/client/enums'
import WxImgPop, { type WxImgPopOptionType } from './views/WxImgPop/index.vue'
import JoinClassPopup from '@xt/www/components/joinClassPopup/index.vue'

@Observer
@Component({
  scrollToTop: true,
  components: {
    MyCourse,
    MyStudy,
    MyAccount,
    MyCalendar,
    Experience,
    StudyRecord,
    Book,
    HeaderUserPanel,
    CalendarMonthPop,
    UserContentPop,
    ExpireBishanPop,
    StudentCardPop,
    WxImgPop,
    JoinClassPopup
  }
})
export default class MyClassroom extends Vue {
  @Ref()
  wxImgPop: {
    openPop: (option: WxImgPopOptionType) => void
    hidePop: () => void
  }

  joinData: {
    visible: boolean
    qrcodeUrl: string
    productId: string
  } = {
    visible: false,
    qrcodeUrl: '',
    productId: ''
  }
  courseItem: (CourseItem & CourseCardUIType) | null = null
  //默认点击去学习都显示不在提醒
  hasShowCallAlert: boolean = false

  @Ref()
  calendarMonthPop: {
    openPop: () => void
    hidePop: () => void
  }

  @Ref()
  userContentPop: {
    showPop: (options: HomeworkOption | DairyOption) => void
    hidePop: () => void
  }

  @Ref()
  studentCardPop: {
    open: () => void
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  get MyClassroomStore() {
    return this.$store.$myV2.Classroom
  }

  hideJoinClassPop() {
    this.joinData.visible = false
  }

  // 调用接口同步数据是否提醒状态
  async changeGroupStatus(productId: string) {
    const res = await this.$ajax.put(EnumApiMy.changeGroupStatus, { productId })
    if (res == true) {
      this.hasShowCallAlert = true
    }
  }

  // 日历弹窗卡片跳转
  async handleCalendarCard(item: CourseRecordCardUIType) {
    const { bizType, bizId } = item

    //  关闭学习日历弹窗
    this.calendarMonthPop.hidePop()

    if (bizType === EnumBizType.Activity) {
      this.wxImgPop.openPop({
        courseType: 'day',
        qrcodeUrl: this.ossProcessImg(this.$images.xt_daily_mini, 288, 288, true),
        openMiniProgramOption: { miniProgrmType: EnumOpenMiniProgramType.DayCourse, path: EnumOpenMiniProgramPage.DayCourse }
      })
      return
    }

    if (bizType === EnumBizType.Show) {
      const qrcodeUrl: string = await this.$store.$storeShow.getQrcodeUrl({
        page: 'pages/levels/index',
        query: `id=${bizId}`
      })
      this.wxImgPop.openPop({
        courseType: 'show',
        qrcodeUrl,
        openMiniProgramOption: {
          miniProgrmType: EnumOpenMiniProgramType.Show,
          path: EnumOpenMiniProgramPage.ShowLevels,
          query: {
            id: bizId
          }
        }
      })
      return
    }

    this.$router.push({
      path: `/course/${bizId}`
    })
  }

  // 卡片点击去学习
  async handleGoLearn(item: CourseItem & CourseCardUIType) {
    this.courseItem = {
      ...item
    }

    const { type, bizId, groupChatStatus, showAssistantUrlFlag, assistantUrl, id } = item

    //如果是直播课，未入群未确认，弹窗;否则跳转
    if (type !== EnumProductTypeQuery.Exhibition && type !== EnumProductTypeQuery.DayCourse && type !== EnumProductTypeQuery.SelfStudy) {
      this.$router.push({
        path: `/course/${bizId}`
      })
      return
    }

    if (groupChatStatus == 2 || groupChatStatus == 1 || this.hasShowCallAlert || !showAssistantUrlFlag) {
      this.goLearnCheck()
      return
    }

    this.joinData = {
      visible: true,
      qrcodeUrl: assistantUrl[0],
      productId: id.toString()
    }
  }

  // 加群弹窗点击去学习
  async handleJoinGoLearn(callMe: boolean) {
    //如果是选中了不在提醒
    if (callMe === true) {
      this.changeGroupStatus(this.joinData.productId)
    }

    await this.goLearnCheck()
  }

  // 去学习逻辑判断
  async goLearnCheck() {
    if (!this.courseItem) return

    const { type, bizId, btnText, productType } = this.courseItem

    if (type === EnumProductTypeQuery.Exhibition) {
      let qrcodeUrl: string = ''
      if (btnText === '去备展') {
        qrcodeUrl = await this.$store.$storeShow.getQrcodeUrl({
          page: 'pages/levels/index',
          query: `id=${bizId}`
        })
      } else {
        qrcodeUrl = await this.$store.$storeShow.getQrcodeUrl({
          page: 'pages/lookingEx/index',
          query: `id=${bizId}`
        })
      }
      this.wxImgPop.openPop({
        courseType: 'show',
        qrcodeUrl,
        openMiniProgramOption: {
          miniProgrmType: EnumOpenMiniProgramType.Show,
          path: btnText === '去备展' ? EnumOpenMiniProgramPage.ShowLevels : EnumOpenMiniProgramPage.ShowLookingEx,
          query: {
            id: bizId
          }
        }
      })
    }

    if (type === EnumProductTypeQuery.DayCourse || type === EnumProductTypeQuery.SelfStudy) {
      this.wxImgPop.openPop({
        courseType: 'day',
        qrcodeUrl: this.ossProcessImg(this.$images.xt_daily_mini, 288, 288, true),
        openMiniProgramOption: { miniProgrmType: EnumOpenMiniProgramType.DayCourse, path: EnumOpenMiniProgramPage.DayCourse }
      })
    }
  }

  handleOpenCard() {
    this.studentCardPop.open()
  }

  handleOpenUserContentPop(data: MyLastReviewResponse) {
    this.userContentPop.showPop({
      type: 'homework',
      homeworkId: data.id
    })
  }

  init(): void {
    this.MyClassroomStore.fetchUserPanelData()
    this.MyClassroomStore.fetchStudyRecordData(this.UserStore.UserInfo.id)
    this.MyClassroomStore.loadMyProductList()
    this.MyClassroomStore.loadMyStudyData()
  }

  created(): void {
    this.init()
  }

  handleOpenCalendarPop() {
    this.calendarMonthPop.openPop()
  }

  handleToSettings() {
    this.$router.push({
      path: `/myv2/settings`
    })
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    this.MyClassroomStore.reset()
  }
}
